// extracted by mini-css-extract-plugin
export default {"form":"styles_form__99+oS","full":"styles_full__p0bD8"};